<template>
    <div>
        <v-btn
            :color="loading || !inputsFilled ? 'grey-lighten-1' : 'accent'"
            :disabled="loading || !inputsFilled"
            @click="clicked"
            :loading="loading"
            rounded
            style="height: 40px; letter-spacing: 1.25px"
            variant="elevated"
            class="text-uppercase text-title-small"
        >
            Calculate
        </v-btn>
        <div style="min-height: 20px">
            <v-expand-transition>
                <div
                    class="text-typography2 pb-0 mb-0"
                    style="font-size: 12px"
                    v-show="!inputsFilled"
                >
                    Required inputs missing
                </div>
            </v-expand-transition>
        </div>
    </div>
</template>
<script setup>
import { computed } from 'vue'

const props = defineProps({
    calc: {
        type: Object,
        required: true,
    },
    loading: {
        type: Boolean,
        default: false,
    },
})
const emit = defineEmits(['click'])

const inputsFilled = computed(() => {
    if (props.calc.inputs) {
        let emptyRequiredInput = false
        props.calc.inputs.forEach((i) => {
            if (!(i.value || i.value === 0) && !i.isOptional)
                emptyRequiredInput = true
        })
        return !emptyRequiredInput
    }
    return true
})

function clicked() {
    emit('click')
}
</script>
<style scoped>
.v-btn--disabled.v-btn--variant-elevated {
    opacity: 0.3 !important;
}
</style>
